import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from "../Icon";
import { IconButtonContainer } from "./styled";
export const IconButton = ({ icon, size, className, color, active, ...rest }) => (_jsx(IconButtonContainer, { className: className, active: active, ...rest, children: _jsx(Icon, { icon: icon, size: size, color: color }) }));
